__turbopack_context__.v({
  "Quote": "Quote-module-scss-module__WgWMzq__Quote",
  "QuoteTitle": "Quote-module-scss-module__WgWMzq__QuoteTitle",
});
